
// @ts-nocheck


export const localeCodes =  [
  "en-US",
  "en-AU"
]

export const localeLoaders = {
  "en-US": [
    {
      key: "locale_en_45US_46json_5648d041",
      load: () => import("#nuxt-i18n/5648d041" /* webpackChunkName: "locale_en_45US_46json_5648d041" */),
      cache: true
    }
  ],
  "en-AU": [
    {
      key: "locale_en_45AU_46json_642b5393",
      load: () => import("#nuxt-i18n/642b5393" /* webpackChunkName: "locale_en_45AU_46json_642b5393" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en-US",
      iso: "en-US",
      domains: [
        "https://us.cimpro.app/"
      ],
      name: "English (US)",
      files: [
        {
          path: "/vercel/path0/i18n/locales/en-US.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en-AU",
      iso: "en-AU",
      domains: [
        "https://www.cimpro.app/",
        "https://cim-pro-saas.vercel.app/",
        "https://staging.cimpro.app/",
        "http://localhost:3000/"
      ],
      name: "English (Australia)",
      files: [
        {
          path: "/vercel/path0/i18n/locales/en-AU.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en-AU",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en-US",
    iso: "en-US",
    domains: [
      "https://us.cimpro.app/"
    ],
    name: "English (US)",
    files: [
      {
        path: "/vercel/path0/i18n/locales/en-US.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en-AU",
    iso: "en-AU",
    domains: [
      "https://www.cimpro.app/",
      "https://cim-pro-saas.vercel.app/",
      "https://staging.cimpro.app/",
      "http://localhost:3000/"
    ],
    name: "English (Australia)",
    files: [
      {
        path: "/vercel/path0/i18n/locales/en-AU.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/